import React , {useState } from "react";
import { useSelector, useDispatch } from 'react-redux'
import 'moment/locale/es';
import Select from "react-select";
import { Button, Card, CardBody, FormGroup, Form, Input } from "reactstrap";

var viewActions = require ('store/view.actions');

var Const = require ('Const');

var Utils = require ('Utils') ;


export const  CourseStudentEvalCard = ( { token, persona, csEval , courseEvals, updateEvals, createEval, delEval, isPreviousCompleted } ) => {

    const formatPeriod = ( period ) => {
        var desde = new Date(period.start_date.replace('Z','')) ;
        var hasta = new Date(period.end_date.replace('Z','')) ;
        let dev = "Del "+ desde.getDate() + '/' + Utils.capitalize(Const.MONTHS[desde.getMonth()].toLowerCase()) +
                    ' al '+ hasta.getDate() + '/' + Utils.capitalize(Const.MONTHS[hasta.getMonth()].toLowerCase()) ;
        
        return dev ;
        }
        
    const [ formData, setFormData] = useState({});
 
    const {isEditing, isSaving } = useSelector(state => ({
        isEditing: state.view.loadingModules.editingEvaluation, 
        isSaving: state.view.loadingModules.savingEvaluation
    }))

    const dispatch = useDispatch() ;

    const setIsEditing = ( value ) => {
        dispatch(viewActions.isLoadingModule('editingEvaluation',value )) ;
    }

    const confirmCreate = () => {
        if (! (formData.qualif_value_id || formData.qualif_value_nbr) ) alert( "Falta seleccionar la calificación") ;
        else {
            if (Object.keys( formData ).length > 0) {
            let qualifValueToSend = '' ;
            if (formData.qualif_value_id) {
                let qualifValue = courseEvals.qualification_values.filter((q) => q.qualif_value_id === formData.qualif_value_id );
                qualifValueToSend = qualifValue[0] ;
            }
            
            createEval( token, csEval.course_subject_id, persona.persona_id, csEval.evaluation_id, 
                qualifValueToSend , formData.qualif_value_nbr, formData.comments )
            setFormData({});
        } 
        setIsEditing( false );
            
        }
    }
    const confirmDelete = () => {
        delEval( token, csEval.course_subject_id, persona.persona_id, csEval.evaluation_id)
    }
  const confirmUpdate = () => {
    if (Object.keys( formData ).length > 0) {
        let qualifValue = {};
        if (formData.qualif_value_id) {
            let selec = courseEvals.qualification_values.filter((q) => q.qualif_value_id === formData.qualif_value_id );
            qualifValue = selec[0];
        }

        updateEvals ( token, csEval.course_subject_id, csEval.persona_id, csEval.evaluation_id, formData, qualifValue )
        setFormData({});
    } 
    setIsEditing( false ) ;
    
  }

    const reduceQualifValuesList = () => {
        if (courseEvals && courseEvals.qualification_values)
            return courseEvals.qualification_values.map( (qualif) => { return { value: qualif.qualif_value_id, label: qualif.name } } ) ;
        else 
            return '';
    }

    const reduceQualifValuesNumbers = [
        { value: "1", label: "1"},
        { value: "2", label: "2"},
        { value: "3", label: "3"},
        { value: "4", label: "4"},
        { value: "5", label: "5"},
        { value: "6", label: "6"},
        { value: "7", label: "7"},
        { value: "8", label: "8"},
        { value: "9", label: "9"},
        { value: "10", label: "10"},
    ]
     


  const handleInputChange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value}  )
  }

//   const actionButtons = () => {
//       return (
//         (isOpen&& 
//             <>
//             { evalExists ?
//                 <>
//                     <Button color="default" size="sm"
//                         onClick={() => setIsEditing( true )} 
//                         >
//                         <span className="btn-label">
//                             <i className="fa fa-pencil"></i>
//                         </span>
//                         Editar
//                     </Button>
//                     {/* <Button 
//                         color="danger" 
//                         size="sm"
//                         onClick={() => setIsEditing( ) } 
//                         >
//                         <span className="btn-label">
//                             <i className="fa fa-ban"></i>
//                         </span>
//                         Eliminar
//                     </Button>   */}
//                 </>
//             :
//                 <Button color="default" size="sm"
//                     onClick={() => setIsEditing( true )} 
//                     >
//                     <span className="btn-label">
//                         <i className="fa fa-pencil"></i>
//                     </span>
//                     Calificar
//                 </Button>
//   }
//         </>
//         )
//       )
//   }

  const saveButtons = () => {
      return (
                <>
                    <hr />
                    <Button color="success" size="sm" disabled={isSaving}
                        
                        onClick={() => { 
                            if (!evalExists) confirmCreate();
                            else confirmUpdate ();
                        } }
                        
                        >
                        {isSaving?
                            <i className="nc-icon nc-refresh-69  fa-spin" />
                            :
                            <>
                                <span className="btn-label">
                                    <i className="fa fa-floppy-o" aria-hidden="true"></i>
                                </span>
                                {evalExists?"Modificar":"Grabar"} 
                            </>
                        }
                    </Button>

                    {/* <Button 
                        color="danger" 
                        size="sm"
                        onClick={() => setIsEditing( false ) } 
                        >
                        <span className="btn-label">
                            <i className="fa fa-ban"></i>
                        </span>
                        Cancelar
                    </Button>   */}
                    {evalExists && 
                        <Button color="danger" size="sm" disabled={isSaving}
                            
                            onClick={() => { 
                                confirmDelete();
                            } }
                            
                            >
                            {isSaving?
                                <i className="nc-icon nc-refresh-69  fa-spin" />
                                :
                                <>
                                    <span className="btn-label">
                                        <i className="fa fa-trash" aria-hidden="true"></i>
                                    </span>
                                    Eliminar 
                                </>
                            }
                        </Button>
                    }
                </>
        )

  }

const isOpen = ( csEval.blocked!=='Y' ) ;
const evalExists = ( csEval.qualif_value_id || csEval.qualif_value_nbr ) ;

const customStyles = {
    singleValue: (provided, state) => ({
      fontWeight: '800'
    })
  }


        return (
        <>
        {csEval && 
            <Card style={{backgroundColor:'#ececec'}}>
                <CardBody>
                    <p  className="eval-title">{csEval.name}</p>

                    {!isPreviousCompleted &&
                        <b>Debe completar las evaluaciones anteriores para poder cargar esta.</b>
                    
                    }
                    {(csEval.show_dt !== "N" ) &&
                        <p>{formatPeriod(csEval)}{ !isOpen && <> <b>Calificación cerrada</b></>}</p>
                    }
                {(!isEditing && !isOpen) || !isPreviousCompleted?
                    <>
                    { evalExists && 
                        <p><b style={{color: csEval.q_color}}>{csEval.q_name}</b>{csEval.q_comments?':':''}{csEval.q_comments}</p> }
                    
                    {/* {actionButtons()} */}
                   </>
                :       
                    <>
                     <Form>
                         <FormGroup>
                              
                         {csEval.evaluation_type === 'NUM'?
                            <Select
                                        classNamePrefix="react-select"
                                        styles={evalExists?customStyles:''}
                                        name="qualif_value_nbr"
                                        defaultValue={Const.getObjectByValue(reduceQualifValuesNumbers, csEval.qualif_value_nbr)}
                                       
                                        onChange={(sel) => 
                                        setFormData({ ...formData, 'qualif_value_nbr': sel.value }  ) }
                                        options={reduceQualifValuesNumbers}
                                        placeholder="Seleccione nota numérica"
                                    />
                            :
                                    <Select
                                        classNamePrefix="react-select"
                                        styles={evalExists?customStyles:''}
                                        name="qualif_value_id"
                                        defaultValue={Const.getObjectByValue(reduceQualifValuesList(), csEval.qualif_value_id)}
                                        onChange={(sel) => 
                                        setFormData({ ...formData, 'qualif_value_id': sel.value }  ) }
                                        options={reduceQualifValuesList()}
                                        placeholder="Seleccione calificacion"
                                    />
                            }
                            {evalExists?
                                <Input
                                    className="fafafa"
                                    defaultValue={csEval.q_comments}
                                    placeholder="Comentarios"
                                    type="textarea"
                                    rows="12"
                                    name="comments"
                                    onChange={handleInputChange}
                                />
                                :
                                <>
                                <Input
                                    className="fafafa"
                                    // value={evalExists?csEval.q_comments:null}
                                    placeholder="Comentarios"
                                    type="textarea"
                                    rows="12"
                                    name="comments"
                                    onChange={handleInputChange}
                                />
                                </>
                            }
                            </FormGroup>
                         </Form>
                    {saveButtons()}

                    </>
                }

                </CardBody>

                </Card>
              }
              </>
          );
    }
